module.exports = __webpack_public_path__ + "static/img/barBg.60719b83.png";